import * as yup from 'yup';
import cpdFormModel from './cpdFormModel';

const {
  formField: {
    ActivityDate,
    Category,
    ActivityType,
    Domains,
    CreditsClaiming,
    Description,
    DevelopmentPurpose
  }
} = cpdFormModel;

export const cpdValidationSchema = yup.object().shape({
  [ActivityDate.name]: yup.date().nullable().required(`${ActivityDate.requiredErrorMsg}`)
    .min(new Date(2025, 4, 1), ActivityDate.minDateErrorMsg),
  [Category.name]: yup.string().required(`${Category.requiredErrorMsg}`),
  [ActivityType.name]: yup.string().required(`${ActivityType.requiredErrorMsg}`),
  [Domains.name]: yup.array().min(1).of(yup.string().required(Domains.requiredErrorMsg)).required(Domains.requiredErrorMsg),
  [CreditsClaiming.name]: yup.number().min(CreditsClaiming.minValue, CreditsClaiming.minimumValueErrorMessage)
    .max(CreditsClaiming.maxValue, CreditsClaiming.maximumValueErrorMessage)
    .required(`${CreditsClaiming.requiredErrorMsg}`),
  [Description.name]: yup.string().required(`${Description.requiredErrorMsg}`)
    .test('len', `${Description.maxStringLengthErrorMsg}`, val => val.length <= Description.maxStringCount),
  [DevelopmentPurpose.name]: yup.string().test('len', `${DevelopmentPurpose.maxStringLengthErrorMsg}`, val => val !== undefined && val.length <= DevelopmentPurpose.maxStringCount)
})
